import styles from "../../../styles/components/dropdown.module.scss";
import { useState, useEffect, useRef } from "react";
import UserImageContainer from "../user-image-container";
import { useTranslations } from 'next-intl';
import Link from "next/link";


type DropdownType = {
    children: any,
    name: string,
    className: string,
    user?: any,
    type?: string,
    mainLink?: string,
}


export default function DropDown({ children, name, className, user, type, mainLink }: DropdownType) {
    const t = useTranslations('Header');
    const [open, setOpen] = useState<Boolean>(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const containerClass = type === 'nav' ? styles.navDropdownContainer : styles.dropdowncontainer;
    const dropdownClass = type === 'nav' ? styles.navDropdown : '';

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setOpen(false);
            }
        };

        if (open) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [open]);

    // Cleanup timeout on unmount
    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    const handleMouseEnter = () => {
        if (type === 'nav') {
            // Clear any existing timeout
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
            setOpen(true);
        }
    };

    const handleMouseLeave = () => {
        if (type === 'nav') {
            // Add a delay before closing the dropdown
            timeoutRef.current = setTimeout(() => {
                setOpen(false);
            }, 300); // 300ms delay
        }
    };

    return <>
        <div 
            className={containerClass} 
            ref={dropdownRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            {type === 'nav' && mainLink ? (
                <Link href={mainLink}>
                    <a className={`${className} ${open ? 'open' : ''}`}>
                        <p>{t(name)}</p>
                        <span className={styles.dropdownArrow}>▼</span>
                    </a>
                </Link>
            ) : (
                <button 
                    className={`${className} ${open ? 'open' : ''}`} 
                    onClick={() => {
                        if (type === 'nav') {
                            // For nav dropdowns, don't toggle on click, just keep it open
                            setOpen(true);
                        } else {
                            // For profile dropdowns, toggle on click
                            setOpen(!open);
                        }
                    }}
                >
                    <p>{t(name)}</p>
                    {type === 'profile' && <UserImageContainer
                        imageName={user.info?.perfil?.imagen}
                        type="header"
                    />}
                </button>
            )}
            {open && (
                <div className={dropdownClass}>
                    {children}
                </div>
            )}
        </div>
    </>
}